import getSubscriptionPlans from 'api/v1/subscriptions/getSubscriptionPlans';
import { parseSubscriptionPlan } from 'components/pages/Subscriptions/Subscription.helper';
import useGetCurrentCustomerData from 'hooks/Authentication/useGetCurrentCustomerData';
import useFeatures from 'hooks/useFeatures';
import type { UseQueryResult } from 'react-query';
import { useQuery } from 'react-query';
import { SubscriptionsCacheKeys } from 'types/cacheKeys.types';
import type {
  PaywallFeatureType,
  SubscriptionPlan,
} from 'types/subscriptions.types';
import type { SubscriptionPlanNameEnum } from 'types/users.types';
import { getStoredAuthData } from 'utils/auth';
import { isWeb } from 'utils/constants';

const useGroupSubscriptionPlans = (
  currentSubscriptionPlan?: SubscriptionPlanNameEnum,
): UseQueryResult<
  (SubscriptionPlan & { featuresContent: PaywallFeatureType[] })[]
> => {
  const { data: user } = useGetCurrentCustomerData();

  const paywallFeaturesList = useFeatures('paywall.paywallFeaturesList');

  return useQuery(
    SubscriptionsCacheKeys.SubscriptionPlans,
    getSubscriptionPlans,
    {
      enabled: !!getStoredAuthData('access_token') && isWeb,
      select: (data) =>
        data
          // BASIC is temporarly removed only from client-side via 'filter' until it's decided to totally remove it
          // from the system
          .filter(
            ({ nickname }: SubscriptionPlan): boolean =>
              (nickname.includes('basic') &&
                currentSubscriptionPlan?.includes('basic')) ||
              !nickname.includes('basic'),
          )
          .map(parseSubscriptionPlan)
          .map((plan) => ({
            ...plan,
            featuresContent: paywallFeaturesList[plan.nickname]?.(
              plan.features,
            ),
          })),
    },
  );
};

export default useGroupSubscriptionPlans;
